import type { LeadMagnetSubmitPayload } from "../../core/api-client.js";
import type { SimulationFormModel } from "./ui-state.js";

export function mapSimulationFormToSubmitPayload(
  form: SimulationFormModel,
): LeadMagnetSubmitPayload {
  return {
    email: form.email.trim(),
    firstName: form.firstName.trim() || undefined,
    source: form.source.trim(),
    consent: true,
    honeypot: form.honeypot,
    answers: {
      slug_parameter: form.slugParameter,
      prix_achat: parseNumber(form.prixAchat),
      loyer: parseNumber(form.loyerAnnuel),
      apport: parseNumber(form.apport),
      duree_simulation: parseNumber(form.dureePret),
      taux: parseDecimal(form.taux),
    },
  };
}

function parseNumber(value: string): number | undefined {
  const normalized = value.trim().replaceAll(/\s+/g, "");
  if (!normalized) return undefined;
  const parsed = Number(normalized);
  return Number.isFinite(parsed) ? parsed : undefined;
}

function parseDecimal(value: string): number | undefined {
  const normalized = value.trim().replace(",", ".");
  if (!normalized) return undefined;
  const parsed = Number(normalized);
  return Number.isFinite(parsed) ? parsed : undefined;
}
